import * as React from 'react';

const tripleClickCount = 3;

export function useTripleClick(callback: () => void): [React.LegacyRef<any>, HTMLElement | undefined] {
  const [elem, setElem] = React.useState<HTMLElement>();
  const countRef = React.useRef(0);
  const maxCountRef = React.useRef(tripleClickCount);
  const timerRef = React.useRef<ReturnType<typeof setTimeout>>();
  const inputCallbackRef = React.useRef<() => void>();
  const callbackRef = React.useCallback(node => {
    setElem(node);
    // callbackRef.current = node;
  }, []);

  React.useEffect(() => {
    inputCallbackRef.current = callback;
  });

  React.useEffect(() => {
    function handler() {
      const isDoubleClick = countRef.current + 1 === maxCountRef.current;
      const timerIsPresent = timerRef.current;
      if (timerIsPresent && isDoubleClick) {
        timerRef.current && clearTimeout(timerRef.current);
        timerRef.current = undefined;
        countRef.current = 0;
        if (inputCallbackRef.current) {
          inputCallbackRef.current();
        }
      }
      countRef.current = countRef.current + 1;
      const timer = setTimeout(() => {
        timerRef.current = undefined;
        countRef.current = 0;
      }, 200);
      timerRef.current && clearTimeout(timerRef.current);
      timerRef.current = timer;
    }
    if (elem) {
      elem.addEventListener('click', handler);
    }

    return () => {
      if (elem) {
        elem.removeEventListener('click', handler);
      }
    };
  }, [elem]);
  return [callbackRef, elem];
}
